module.exports = __webpack_public_path__ + "static/media/fileIcon.bb970f3c.svg";